var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-empty',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.opt.isEmpty),expression:"opt.isEmpty"}]},'a-empty',_vm.opt,false))}
var staticRenderFns = []

export { render, staticRenderFns }